import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WarningIndicatorDirective } from './warning-indicator.directive';

@NgModule({
  declarations: [WarningIndicatorDirective],
  imports: [CommonModule],
  exports: [WarningIndicatorDirective]
})
export class WarningIndicatorModule {}

export * from './warning-indicator.directive';
